<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title" *ngIf="inner_customer_id==0">Edit Customer '{{Edit_Customer_Record.code}}'</h5>
    <h5 class="card-title" *ngIf="inner_customer_id>0">Customer Information '{{Edit_Customer_Record.code}}'</h5>
    <form [formGroup]="EdCustomer">

      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Customer Name (*) </label>
          <input formControlName="Name" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_Name().valid && get_Form_Name().touched"
            class="form-text text-muted MyErrorRedColor">Enter the customer name.</small>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Customer Name (English) </label>
          <input formControlName="Name_En" type="text" class="form-control" placeholder="Type here...">
        </div>
      </div>

      
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Customer Code (*) </label>
          <input formControlName="Code" type="number" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_Code().valid && get_Form_Code().touched"
            class="form-text text-muted MyErrorRedColor">Enter the customer code.</small>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Type Customer </label>
          <select class="custom-select" formControlName="Foreign" >
            <option value="0">Customer Internal</option>
            <option value="1">Foreign Customer</option>
          </select>
        </div>
        <div class="form-group col-md-4" [hidden]="get_Form_Foreign().value=='1'">
          <label for="exampleInputEmail1">National Identifier (*) </label>
          <input formControlName="ShenasehMeli" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_ShenasehMeli().valid && get_Form_ShenasehMeli().touched"
            class="form-text text-muted MyErrorRedColor">Enter the national identifier.</small>
        </div>
      </div>

      <div class="row">

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Province </label>
          <select class="custom-select" formControlName="ProvinceId" (change)="ProvinceChange()">
            <option value="0">Select</option>
            <option *ngFor="let item of DataList_Province" [value]="item.code">{{item.title}}</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">County</label>
          <select class="custom-select" formControlName="CityId">
            <option value="0">Select</option>
            <option *ngFor="let item of DataList_City" [value]="item.id">{{item.title}}</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">
            Field of Activity
            <button (click)="OnAdd_RabetMasolCustomer_FeildActivity()" type="button"  *ngIf="inner_customer_id==0"
              [disabled]="get_Form_FeildActivity().value == '0' " class="btn  btn-success"><i
                class="fa  fa-plus-circle"></i> </button>
          </label>
          <select class="custom-select" formControlName="FeildActivity" *ngIf="inner_customer_id==0">
            <option value="0">Select</option>
            <option *ngFor="let item of DataList_FeildActivity" [value]="item.id">{{item.title}}</option>
          </select>

          <table class="mb-0 table table-bordered table-3 text-center table-striped"
            *ngIf="RabetMasolCustomer_FeildActivity.length>0">
            <tr class="bg-warning" *ngFor="let item of RabetMasolCustomer_FeildActivity">
              <td>
                {{item.title}}
              </td>
              <td>
                <a style="cursor: pointer;"
                  (click)="RabetMasolCustomer_FeildActivity_Delete(RabetMasolCustomer_FeildActivity.indexOf(item))"><i
                    class="fa fa-remove"></i> Delete </a>
              </td>
            </tr>
          </table>

        </div>
      </div>

      <div class="row" style="display: none;">

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Registration Number</label>
          <input type="number" formControlName="ShomarehSabt" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_ShomarehSabt().valid && get_Form_ShomarehSabt().touched"
            class="form-text text-muted MyErrorRedColor">Enter the registration number.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Economic Code</label>
          <input type="number" formControlName="CodeEghtesadi" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_CodeEghtesadi().valid && get_Form_CodeEghtesadi().touched"
            class="form-text text-muted MyErrorRedColor">Enter the economic code.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1"> National ID (without leading zero) </label>
          <input type="number" formControlName="CodeMeli" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_CodeMeli().valid && get_Form_CodeMeli().touched"
            class="form-text text-muted MyErrorRedColor">Enter the national ID.</small>
        </div>
      </div>

      <br />
      <hr />
      <br />

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Managing Director Full Name </label>
          <input type="text" formControlName="ModirAmelName" class="form-control" placeholder="Type here...">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Mobile Number (without leading zero) (*) </label>
          <input type="number" formControlName="ModirAmelMobile" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_ModirAmelMobile().valid && get_Form_ModirAmelMobile().touched"
            class="form-text text-muted MyErrorRedColor">Enter the mobile number.</small>
        </div>
      </div>
      <div class="row" style="display: none;">

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Phone</label>
          <input type="number" formControlName="ModirAmelTel" class="form-control" placeholder="Type here...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Internal</label>
          <input type="number" formControlName="ModirAmelDakheli" class="form-control"
            placeholder="Type here...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Email</label>
          <input type="email" formControlName="ModirAmelEmail" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_ModirAmelEmail().valid && get_Form_ModirAmelEmail().touched"
            class="form-text text-muted MyErrorRedColor">Enter the email address.</small>
        </div>
      </div>
    </form>



    <br />
    <hr />
    <br />

    <h5 *ngIf="AddressForm_Edit_Id==-1"> Address </h5>
    <h5 *ngIf="AddressForm_Edit_Id>-1"> Edit Address </h5>

    <form [formGroup]="AddressCustomer" (submit)="OnSubmit_AddressForm()">

      <input type="hidden" formControlName="id">

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Address Title</label>
          <select class="custom-select" formControlName="title_id">
            <option value="0">Select</option>
            <option *ngFor="let item of DataList_Address_Title" [value]="item.id">{{item.title}}</option>
          </select>
        </div>
        <div class="form-group col-md-8">
          <label for="exampleInputEmail1">Address</label>
          <input type="text" formControlName="address" class="form-control" placeholder="Type here...">
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Certificate Address (*)  </label>
          <input type="text" formControlName="certificateAddress" class="form-control"
            placeholder="Type here...">
          <small
            *ngIf="!get_Form_AddressCustomer_certificateAddress().valid && get_Form_AddressCustomer_certificateAddress().touched"
            class="form-text text-muted MyErrorRedColor">Enter the certificate address (maximum 50 characters). </small>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Certificate Address (English)  </label>
          <input type="text" formControlName="certificateAddress_En" class="form-control"
            placeholder="Type here...">
          <small
            *ngIf="!get_Form_AddressCustomer_certificateAddress_En().valid && get_Form_AddressCustomer_certificateAddress_En().touched"
            class="form-text text-muted MyErrorRedColor">Enter the certificate address (maximum 50 characters). </small>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Postal Code (*)  </label>
          <input type="number" formControlName="codepost" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_AddressCustomer_codepost().valid && get_Form_AddressCustomer_codepost().touched"
            class="form-text text-muted MyErrorRedColor">Enter the postal code. </small>
        </div>

        <div class="form-group col-md-6" style="display: none;">
          <label for="exampleInputEmail1">P.O. Box</label>
          <input type="number" formControlName="sandoghpost" class="form-control" placeholder="Type here...">
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Area Code</label>
          <input type="number" formControlName="pishShomareh" class="form-control" placeholder="Type here...">
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">
            Phone (*)
            <button (click)="OnAdd_AddressCustomer_Tel()" type="button"
              [disabled]="!get_Form_AddressCustomer_Tel().valid || get_Form_AddressCustomer_Tel().value =='' || get_Form_AddressCustomer_Tel().value == null "
              class="btn  btn-success"><i class="fa  fa-plus-circle"></i> </button>
          </label>
          <input type="number" formControlName="Tel" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_AddressCustomer_Tel().valid && get_Form_AddressCustomer_Tel().touched"
            class="form-text text-muted MyErrorRedColor">Enter the phone number.</small>

          <table class="mb-0 table table-bordered table-3 text-center table-striped"
            *ngIf="AddressCustomer_Tel.length>0">
            <tr class="bg-warning" *ngFor="let item of AddressCustomer_Tel">
              <td>
                {{item.title}}
              </td>
              <td>
                <a style="cursor: pointer;" (click)="AddressCustomer_Tel_Delete(item.id)"><i
                    class="fa fa-remove"></i> Delete </a>
              </td>
            </tr>
          </table>
        </div>

        <div class="form-group col-md-3" style="display: none;">
          <label for="exampleInputEmail1">Internal</label>
          <input type="number" formControlName="Dakheli" class="form-control" placeholder="Type here...">
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Fax</label>
          <input type="number" formControlName="Fax" class="form-control" placeholder="Type here...">
        </div>

      </div>

      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">
            Email
            <button (click)="OnAdd_AddressCustomer_Email()" type="button"
              [disabled]="!get_Form_AddressCustomer_Email().valid || get_Form_AddressCustomer_Email().value =='' || get_Form_AddressCustomer_Email().value == null "
              class="btn  btn-success"><i class="fa  fa-plus-circle"></i> </button>
          </label>
          <input type="text" formControlName="Email" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_AddressCustomer_Email().valid && get_Form_AddressCustomer_Email().touched"
            class="form-text text-muted MyErrorRedColor">Enter the email address.</small>

          <table class="mb-0 table table-bordered table-3 text-center table-striped"
            *ngIf="AddressCustomer_Email.length>0">
            <tr class="bg-warning" *ngFor="let item of AddressCustomer_Email">
              <td>
                {{item.title}}
              </td>
              <td>
                <a style="cursor: pointer;" (click)="AddressCustomer_Email_Delete(item.id)"><i
                    class="fa fa-remove"></i> Delete </a>
              </td>
            </tr>
          </table>
        </div>

        <div class="form-group col-md-9">
          <label for="exampleInputEmail1">Description</label>
          <input type="text" formControlName="Dsc" class="form-control" placeholder="Type here...">
        </div>
      </div>





      <button *ngIf="AddressForm_Edit_Id==-1" type="submit" [disabled]="!AddressCustomer.valid" class="btn btn-success"
        style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Address </button>
      <button *ngIf="AddressForm_Edit_Id==-1" type="reset" class="btn btn-danger" style="margin-right: 5px;"><i
          class="fa fa-times-rectangle"></i> Cancel </button>

      <button *ngIf="AddressForm_Edit_Id>-1" type="submit" [disabled]="!AddressCustomer.valid" class="btn btn-info"
        style="margin-right: 5px;"><i class="fa  fa-edit"></i> Edit Address </button>
      <button *ngIf="AddressForm_Edit_Id>-1" type="button" (click)="AddressForm_Edit_Cancel()" class="btn btn-danger"
        style="margin-right: 5px;"><i class="fa fa-times-rectangle"></i> Cancel Editing </button>

    </form>


    <br />
    <br />

    <div class="table-responsive" *ngIf="DataList_Address.length>0 && AddressForm_Edit_Id==-1">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            
            <th>Address Title</th>
            <th>Address</th>
            <th>Postal Code</th>
            <th>Area Code</th>
            <th>Phone</th>
            <th>Fax</th>
            <th>Email</th>
            <th>Description</th>
            

            
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <ng-container  *ngFor="let item of DataList_Address">
            <tr>
              <td rowspan="2">{{DataList_Address.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td>{{item.address}}</td>

              <td>{{item.codepost}}</td>
              <td>{{item.pishShomareh}}</td>
              <td>
                <table class="mb-0 table table-bordered table-3 text-center table-striped">
                  <tr style="background-color: #accba7;" *ngFor="let itemDetail of item.tel">
                    <td>
                      {{item.tel.indexOf(itemDetail)+1}}
                    </td>
                    <td>
                      {{itemDetail.title}}
                    </td>
                  </tr>
                </table>
              </td>
              <td>{{item.fax}}</td>
              <td>
                <table class="mb-0 table table-bordered table-3 text-center table-striped">
                  <tr style="background-color: #accba7;" *ngFor="let itemDetail of item.Email">
                    <td>
                      {{item.Email.indexOf(itemDetail)+1}}
                    </td>
                    <td>
                      {{itemDetail.title}}
                    </td>
                  </tr>
                </table>
              </td>
              <td>{{item.dsc}}</td>
              <td rowspan="2">
                <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                  <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Actions
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a style="cursor: pointer;" (click)="AddressForm_Edit(DataList_Address.indexOf(item))"
                        class="dropdown-item"><i class="fa fa-edit"></i> Edit </a>
                      <a style="cursor: pointer;" (click)="AddressForm_Delete(DataList_Address.indexOf(item))"
                        class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>
                    </div>
                  </div>
                </div>
              </td>
  
            </tr>

            <tr>
              <th>Certificate Address</th>
              <td colspan="3">{{item.certificateAddress}}</td>
              <th>Certificate Address (English)</th>
              <td colspan="3">{{item.certificateAddress_en}}</td>
            </tr>

          </ng-container>

        </tbody>
      </table>
    </div>
    <br />
    <hr />
    <br />

    <app-CutomerKarshnasForm
      [inner_Customer]="EditRecord"
      (outter_KarshnasMasol)="set_KarshnasMasol($event)">

    </app-CutomerKarshnasForm>


    <div *ngIf="inner_customer_id==0">

      <button *ngIf="!Proccesing_OnSubmitForm" type="button" (click)="OnSubmitForm()" [disabled]="!EdCustomer.valid"
      class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-plus"></i> Confirm and Save Customer Information
      </button>
      <button *ngIf="Proccesing_OnSubmitForm" type="button" class="btn btn-info" style="margin-right: 5px;"> Please wait... <i class="fa fa-spin fa-spinner"></i> </button>
      <button routerLink="/Customer" *ngIf="!Proccesing_OnSubmitForm" type="button" class="btn btn-warning"><i
          class="fa fa-mail-reply"></i> Back </button>

    </div>


  </div>
</div>
